import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

const StyledDropdownButton = styled.summary<{ $disabled?: boolean }>`
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  appearance: none;
  text-decoration: none;
  color: var(--text-color-normal);
  opacity: ${({ $disabled }: any) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }: any) => ($disabled ? 'none' : 'auto')};

  &::-webkit-details-marker {
    display: none;
  }

  .procedure-filter-dropdown & {
    color: ${({ theme }) => theme.colors.text.body};
    padding: 1px 3px;
    line-height: 1;
  }

  .dropdown-profile & {
    padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[3]};
    border: 0;
    border-radius: ${({ theme }) => theme.radii.hard};
    box-shadow: none;
    background: none;
    cursor: pointer;
    transition: background 220ms ease-in-out;

    &:hover {
      background-color: var(--color-neutral-contrast-02);

      html[data-color-mode='dark'] & {
        background-color: var(--color-neutral-contrast-03);
      }
    }

    &:focus {
      outline: none;
      box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
    }
  }
`;

type DropdownButtonProps = {
  children?: string | ReactNode;
  role?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  tabIndex?: number;
  className?: string;
  title?: string;
  disabled?: boolean;
};

function DropdownButton({
  children,
  role,
  onClick,
  tabIndex,
  className,
  title,
  disabled,
}: DropdownButtonProps): ReactElement {
  return (
    <StyledDropdownButton
      tabIndex={tabIndex}
      as="summary"
      onClick={onClick}
      role={role}
      className={className}
      title={title}
      $disabled={disabled}
    >
      {children}
    </StyledDropdownButton>
  );
}

export default DropdownButton;
